import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'AVPU'
})
export class AVPUPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        switch (value) {
            case 1:
                return "A";
            case 2:
                return "V";
            case 3:
                return "P";
            case 4:
                return "U";
            default:
                return "N/A";
        }
  }
}



// WEBPACK FOOTER //
// ./src/app/brightserve/pipes/avpu.pipe.ts